import workspaceQuery from '../../../graphql/queries/company/FinancialAuditWorkspaceQuery.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const FinancialAudit = {
  type: 'FinancialAudit',
  title: 'Audit Transactions',
  workspaceUrl: '/Company/FinancialAudit/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'TRANSACTION_AUDIT',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default FinancialAudit;
